import * as React from 'react';
import { CoreAutocomplete } from '../internal/WixUiCoreComponents/components/CoreAutocomplete';
import { ChevronDown } from '@wix/wix-ui-icons-common';
import { st, classes } from './Autocomplete.st.css';
import { ErrorMessageWrapper } from '../ErrorMessageWrapper';
import { AutocompleteProps, AutocompleteType } from './types';

export const Autocomplete: AutocompleteType = ((props: AutocompleteProps) => {
  const {
    errorMessage,
    error,
    suffix,
    className,
    theme,
    ...coreAutocompleteProps
  } = props;
  const { disabled } = props;

  return (
    <ErrorMessageWrapper
      error={error}
      errorMessage={errorMessage}
      disabled={disabled}
      render={(errorProps) => (
        <CoreAutocomplete
          className={st(classes.root, { error, theme }, className)}
          {...coreAutocompleteProps}
          error={errorProps.error}
          data-hook={props['data-hook']}
          suffix={
            <span className={classes.suffix}>
              <ChevronDown
                width={14}
                height={14}
                viewBox="8 7 9 10"
                className={classes.arrowIcon}
              />
              {suffix}
            </span>
          }
        />
      )}
    />
  );
}) as AutocompleteType;

Autocomplete.createOption = CoreAutocomplete.createOption;
Autocomplete.createDivider = CoreAutocomplete.createDivider;
